<script>
import SkyScroll from 'sky-scroll';

export default {
	props: {
		showBurgerMenu: Boolean,
	},
	data() {
		return {
			fixed: false,
			lastScrollY: 0,
			isMobile: window.innerWidth <= 800,
		};
	},
	computed: {
		activeOverlays() {
			return this.$store.getters['skyOverlay/hasActive'];
		},
	},
	mounted() {
		SkyScroll.track(this.$el, (scrolled, dimensions, viewport) => {
			if (!this.activeOverlays) {
				this.fixed = (viewport.scroll.y > dimensions.top);
			}
		});
	},
	beforeDestroy() {
		SkyScroll.untrack(this.$el);
	},
};
</script>

<template src="./RoHeaderBurger.html"></template>



// WEBPACK FOOTER //
// RoHeaderBurger.vue?f30d0e9c